import moment from "moment";
import { AutomationTypeEnum, RunIntervalEnum } from "~/pages/automation/enums";
import { DateFormatEnum } from "~/enums";

const isGlobal = (state) => state.isGlobal;
const title = (state, getters) => {
  const automationType = getters.isGlobal ? "Globale automation " : "Automation ";
  return state.configuredAutomationInterface?.title || automationType;
};
const automationInterface = (state) => state.configuredAutomationInterface;

const hasAutomationResults = (state) => state.automationResults
  && state.automationResults.length > 0;

const hasSearchables = (state) => state.searchables
  && state.searchables.length > 0;

const createsSignal = (state) => state?.configuredAutomationInterface?.create_signal;
const createsTask = (state) => state?.configuredAutomationInterface?.create_task;
// eslint-disable-next-line max-len
const sendsEmail = (state, getters) => state?.configuredAutomationInterface?.send_email || getters.isCampaign;
const isRecurring = (state) => state?.configuredAutomationInterface?.is_recurring;
// eslint-disable-next-line max-len
const isCampaign = (state) => state?.configuredAutomationInterface?.type === AutomationTypeEnum.CAMPAIGN;
// eslint-disable-next-line max-len
const isSelection = (state) => state?.configuredAutomationInterface?.type === AutomationTypeEnum.SELECTION;
// eslint-disable-next-line max-len
const isDataEnrichment = (state) => state?.configuredAutomationInterface?.type === AutomationTypeEnum.DATA_ENRICHMENT;

const isActive = (state) => state?.configuredAutomationInterface?.active;

// eslint-disable-next-line max-len
const hasUnprocessedResults = (state) => state?.configuredAutomationInterface?.pending_confirmation > 0;
const runInterval = (state) => state?.configuredAutomationInterface?.run_interval;

const configuredAutomationInterface = (state) => state.configuredAutomationInterface;

const runIntervalDescription = (state, getters) => {
  switch (getters.runInterval) {
    case RunIntervalEnum.NEVER:
      return "nooit";
    case RunIntervalEnum.ONCE:
      return "eenmalig";
    case RunIntervalEnum.DAILY:
      return "dagelijks";
    case RunIntervalEnum.WEEKLY:
      return "wekelijks";
    case RunIntervalEnum.MONTHLY:
      return "maandelijks";
    case RunIntervalEnum.QUARTERLY:
      return "ieder kwartaal";
    case RunIntervalEnum.YEARLY:
      return "jaarlijks";
    default:
      return "onbekend";
  }
};

const automationDescription = (state, getters) => {
  if (getters.runInterval === RunIntervalEnum.NEVER || getters.runInterval === undefined) {
    return RunIntervalEnum.NEVER;
  }
  if (getters.isRecurring === false) {
    return RunIntervalEnum.ONCE;
  }
  return RunIntervalEnum.RECURRING;
};

const lastRanAt = (state) => {
  if (!state.configuredAutomationInterface?.recurring
    && state.configuredAutomationInterface?.last_ran_at
  ) {
    return moment(state.configuredAutomationInterface?.last_ran_at)
      .format(DateFormatEnum.NEW_DISPLAY_DATE);
  }

  return "Nog niet uitgevoerd";
};

const hasRan = (state) => !!state.configuredAutomationInterface?.last_ran_at;

const nextSendDate = (state, getters) => {
  if (!state.configuredAutomationInterface?.is_recurring
    && state.configuredAutomationInterface?.last_ran_at
  ) {
    return moment(state.configuredAutomationInterface?.last_ran_at)
      .format(DateFormatEnum.NEW_DISPLAY_DATE);
  }

  if (getters.runInterval === RunIntervalEnum.ONCE && getters.hasRan === false) {
    return "eerstvolgende handmatige uitvoering";
  }

  switch (getters.runInterval) {
    case RunIntervalEnum.NEVER:
      return ", niet deze staat uit.";
    case RunIntervalEnum.DAILY:
      return moment()
        .add(1, "day")
        .format(DateFormatEnum.NEW_DISPLAY_DATE);
    case RunIntervalEnum.WEEKLY:
      return moment()
        .startOf("isoWeek")
        .add(1, "week")
        .format(DateFormatEnum.NEW_DISPLAY_DATE);
    case RunIntervalEnum.MONTHLY:
      return moment()
        .startOf("month")
        .add(1, "month")
        .format(DateFormatEnum.NEW_DISPLAY_DATE);
    case RunIntervalEnum.QUARTERLY:
      return moment()
        .startOf("month")
        .add(3, "month")
        .format(DateFormatEnum.NEW_DISPLAY_DATE);
    case RunIntervalEnum.YEARLY:
      return moment()
        .startOf("month")
        .add(1, "year")
        .format(DateFormatEnum.NEW_DISPLAY_DATE);
    default:
      return "";
  }
};

const searchDescription = (state) => state.configuredAutomationInterface?.search?.data?.name;
const extendingSearchesDescription = (state) => {
  if (state?.configuredAutomationInterface?.extending_searches?.data?.length === 0) {
    return "Geen sub-selecties.";
  }
  return state.configuredAutomationInterface?.extending_searches?.data?.map((search) => search.name).join(", ");
};

const automationKey = (state) => {
  if (state.configuredAutomationInterface === null) {
    return "";
  }

  if (state.isGlobal) {
    return `global-automation-configuration-${state.configuredAutomationInterface.id}`;
  }

  return `automation-${state.configuredAutomationInterface.id}`;
};

export default {
  automationKey,
  automationDescription,
  automationInterface,
  createsSignal,
  createsTask,
  extendingSearchesDescription,
  hasAutomationResults,
  hasSearchables,
  hasUnprocessedResults,
  isActive,
  isCampaign,
  isDataEnrichment,
  isGlobal,
  isRecurring,
  isSelection,
  hasRan,
  lastRanAt,
  nextSendDate,
  runInterval,
  runIntervalDescription,
  searchDescription,
  sendsEmail,
  title,
  configuredAutomationInterface,
};
